import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

export const styles: IStyles = {
    fadeNormalEnter: {
        opacity: 0.01,
    },
    fadeNormalEnterActive: {
        opacity: 1,
        transition: `opacity 300ms ease-in-out`,
    },
    fadeNormalLeave: {
        opacity: 1,
    },
    fadeNormalLeaveActive: {
        opacity: 0.01,
        transition: `opacity 300ms ease-in-out`,
    },
}

addStyles(styles)
export default styles
